<template>

<div class="mainContainerPerson">
  <h5>Admin Edit Person Form</h5>
<!--   {{ personId }}
  {{ myPersonEdit }}
  {{ currentNote }} -->

  <div class="formContainerPerson">
    <form @submit="Submit" v-if="this.myPersonEdit">

      <div class="row">
        <div class="col">
          <TextInputVue input-id="firstName" label-text="First Name:" :input-v-model="this.myPersonEdit.firstName" object-key="firstName" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>
        </div>
        <div class="col">
          <TextInputVue input-id="middleName" label-text="Middle Name:" :input-v-model="this.myPersonEdit.middleName" object-key="middleName" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>
        </div>
        <div class="col">
          <TextInputVue input-id="lastName" label-text="Last Name:" :input-v-model="this.myPersonEdit.lastName" object-key="lastName" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <DropdownInputVue input-id="countryId" label-text="Nationality:" :input-v-model="this.myPersonEdit.countryId" object-key="countryId" :option-list="this.countriesDropdownValues" @update-form="UpdateForm" ></DropdownInputVue>
        </div>
        <div class="col">
          <DropdownInputVue input-id="contractId" label-text="Contract:" :input-v-model="this.myPersonEdit.contractId" object-key="contractId" :option-list="this.contractsDropdownValues" @update-form="UpdateForm" ></DropdownInputVue>
        </div>
        <div class="col">
          <DropdownInputVue  input-id="securityType" label-text="Security Type:" :input-v-model="this.myPersonEdit.securityType" object-key="securityType" :option-list="this.securityTypesDropdownValues" @update-form="UpdateForm"  ></DropdownInputVue>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <TextInputVue input-id="aal" label-text="AAL:" :input-v-model="this.myPersonEdit.aalNumber" object-key="aalNumber" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>
        </div>
        <div class="col">
          <label for="aalDate" class="form-label">AAL Date:</label>
          <input type="date" class="form-control" id="aalDate" v-model="myPersonEdit.aalDate" >
        </div>
        <div class="col">
          <label for="aalExpireDate" class="form-label">AAL Expired:</label>
          <input type="date" class="form-control" id="aalExpireDate" v-model="myPersonEdit.aalExpireDate" >
        </div>
      </div>

      <div class="row">
        <div class="col">
          <RadioBoolInput input-id="isRenewal" label-text="Renewal:" :input-v-model="this.myPersonEdit.isRenewalBool" object-key="isRenewalBool" @update-form="UpdateForm"  :disabled="disabled" bool-true-text="Yes" bool-false-text="No"></RadioBoolInput>
        </div>
        <div class="col">
          <TextInputVue input-id="email" label-text="Email:" :input-v-model="this.myPersonEdit.email" object-key="email" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>
        </div>
        <div class="col">
          <DropdownInputVue input-id="bioVerified" label-text="BV Status:" :input-v-model="this.myPersonEdit.bioVerified" object-key="bioVerified" :option-list="this.bvStatusDropdownValues" @update-form="UpdateForm" ></DropdownInputVue>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <DropdownInputVue input-id="armingStatusId" label-text="Arming Status:" :input-v-model="this.myPersonEdit.armingStatusId" object-key="armingStatusId" :option-list="this.armingStatusesDropdownValues" @update-form="UpdateForm" ></DropdownInputVue>
        </div>
        <div class="col">
          <label for="armingConfirmedDate" class="form-label">Arming Confirmed:</label>
          <input type="date" class="form-control" id="armingConfirmedDate" v-model="myPersonEdit.armingConfirmedDate" >
        </div>
        <div class="col">
          <RadioBoolInput input-id="spotArming" label-text="LOA AW:" :input-v-model="this.myPersonEdit.spotArming" object-key="spotArming" @update-form="UpdateForm"  :disabled="disabled" bool-true-text="Yes" bool-false-text="No"></RadioBoolInput>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <RadioBoolInput input-id="armed" label-text="Armed:" :input-v-model="this.myPersonEdit.armed" object-key="spotArming" @update-form="UpdateForm"  :disabled="disabled" bool-true-text="Yes" bool-false-text="No"></RadioBoolInput>
        </div>
        <div class="col-md-4">
          <label for="inTheaterArrivalDate" class="form-label">In Theater Date:</label>
          <input type="date" class="form-control" id="inTheaterArrivalDate" v-model="myPersonEdit.inTheaterArrivalDate" >
        </div>

      </div>
  
    <div class="row">

    <div class="col">
      
      <TextInputVue input-id="loa" label-text="LOA:" :input-v-model="this.myPersonEdit.spotDTSID" object-key="spotDTSID" @update-form="UpdateForm" @blur="v$.myPersonEdit.spotDTSID.$touch" :my-errors="v$.myPersonEdit.spotDTSID.$errors" :disabled="disabled"></TextInputVue>

    </div>

    <div class="col">

      <DropdownInputVue input-id="campLocationId" label-text="Camp Location:" :input-v-model="this.myPersonEdit.campLocationId" object-key="campLocationId" :option-list="this.campLocationsDropdownValues" @update-form="UpdateForm" @blur="v$.myPersonEdit.campLocationId.$touch" :my-errors="v$.myPersonEdit.campLocationId.$errors"  :disabled="disabled" ></DropdownInputVue>

    </div>

    <div class="col">
      
      <TextInputVue input-id="usn" label-text="Passport/Taskera/NIN:" :input-v-model="this.myPersonEdit.usn" object-key="usn" @update-form="UpdateForm" @blur="v$.myPersonEdit.usn.$touch" :my-errors="v$.myPersonEdit.usn.$errors" :disabled="disabled"></TextInputVue>

    </div>

  </div>

  <div class="row">

    <div class="col">

      <TextInputVue input-id="bioGuid" label-text="BioGuid:" :input-v-model="this.myPersonEdit.bioGuid" object-key="bioGuid" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>

    </div>

    

    <div class="col">

      <DropdownInputVue input-id="companyId" label-text="Employer:" :input-v-model="this.myPersonEdit.companyId" object-key="companyId" :option-list="this.companiesDropdownValues" @update-form="UpdateForm" @blur="v$.myPersonEdit.companyId.$touch" :my-errors="v$.myPersonEdit.companyId.$errors"  :disabled="disabled" ></DropdownInputVue>

    </div>

    <div class="col">

      <RadioBoolInput input-id="dodCiv" label-text="DoD Civilian:" :input-v-model="this.myPersonEdit.dodCiv" object-key="dodCiv" @update-form="UpdateForm" @blur="v$.myPersonEdit.dodCiv.$touch" :my-errors="v$.myPersonEdit.dodCiv.$errors" :disabled="disabled" bool-true-text="Yes" bool-false-text="No"></RadioBoolInput>

    </div>

  </div>

  <div class="row">

    <div class="col-md-4">
      <label for="deployStartDate" class="form-label">Deploy Start Date (from LOA):</label>
      <input type="date" class="form-control" id="deployStartDate" v-model="myPersonEdit.deployStartDate" >
    </div>

    <div class="col-md-4">
      <label for="deployEndDate" class="form-label">Deploy End Date (from LOA):</label>
      <input type="date" class="form-control" id="deployEndDate" v-model="myPersonEdit.deployEndDate" @blur="v$.myPersonEdit.deployEndDate.$touch" :my-errors="v$.myPersonEdit.deployEndDate.$errors"   >
      <div class="errorMessageForm" v-for="error of v$.myPersonEdit.deployEndDate.$errors" :key="error.$uid">
        {{error.$message}}
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col">

      <label for="notesTextarea" class="form-label" id="lrNote">Add LR Notes</label>
      <textarea class="form-control" v-model="currentLRNote" rows="8" aria-labelledby="lrNote"></textarea>

    </div>

    <div class="col notesContainerContainer">
      
      <label for="notesColumn" class="form-label">Saved LR Notes</label>
      <div v-if="myPersonEdit.lrNotes != null" class="notesColumn">
     
        <div class="notesContainer">
          <div class="loadedNote">{{ myPersonEdit.lrNotes }}</div>
        </div>
        
      </div>
      <div class="notesColumn" v-else>
        No Saved Notes...
      </div>
    </div>

  </div>

  <div class="row">

<div class="col">

  <label for="notesTextarea" class="form-label" id="newNote">Add ACOD Notes</label>
  <textarea class="form-control" v-model="currentACODNote" rows="8" aria-labelledby="newNote"></textarea>

</div>

<div class="col notesContainerContainer">
  
  <label for="notesColumn" class="form-label">Saved ACOD Notes</label>
  <div v-if="myPersonEdit.acodNotes != null" class="notesColumn">
 
    <div class="notesContainer">
      <div class="loadedNote">{{ myPersonEdit.acodNotes }}</div>
    </div>
    
  </div>
  <div class="notesColumn" v-else>
    No Saved Notes...
  </div>
</div>

</div>

  <div class="formButtonContainer">
    <button type="submit" class="btn btn-primary">Save</button>

    <button v-if="myPersonEdit.armingStatusId == 1 || myPersonEdit.armingStatusId == 10" type="submit" class="btn btn-success" @click="Submit($event, 3)">Submit to QC</button>
    <button v-if="myPersonEdit.armingStatusId == 3" type="submit" class="btn btn-success" @click="Submit($event, 10)">QC Complete</button>
    <button v-if="myPersonEdit.armingStatusId != 11" type="submit" class="btn btn-warning" @click="Submit($event, 11)">Send to Hold</button>
  </div>

    </form>
  </div>
  

  <div class="updateTextContainerContainer" style="position:relative;">
    <div class="updateTextContainer" v-if="updateText != ''">
      {{ updateText }}
    </div>
  </div>
</div>
 
 
</template> 
  
<script> 
  import $ from "jquery";
  import {ajaxGetAndReturn} from "@/components/helpers/utilities.js";
  import { store } from "@/store/store.js";
  import TextInputVue from "@/components/formComponents/TextInput.vue";
  import DropdownInputVue from "@/components/formComponents/DropdownInput.vue";
  import RadioBoolInput from "@/components/formComponents/RadioBoolInput.vue"; 
  import { useVuelidate } from '@vuelidate/core';
  import { 
    required, 
    helpers, 
    minValue,
  } 
    from '@vuelidate/validators'; 

  export default {
    name: "EditPersonForm",
    components: {
      TextInputVue, DropdownInputVue, RadioBoolInput
    }, 
    setup () {
      return { v$: useVuelidate() }
    },
    data(){
      return{
        isMounted : false,
        myPersonEdit:null,
        companiesDropdownValues:null,
        campLocationsDropdownValues:null,
        countriesDropdownValues:null,
        contractsDropdownValues:null,
        securityTypesDropdownValues:null,
        bvStatusDropdownValues:null,
        armingStatusesDropdownValues:null,
        currentLRNote:"",
        currentACODNote:"",
        updateText:"",
      }
    },
    props: {
      personId:Number,
    },

    created(){ // called BEFORE rendering (load data here)
      console.log(this.personId);
      ajaxGetAndReturn(store.webAPIUrl + "people/GetContractPersonEdit/" + this.personId, (result) =>{
        this.myPersonEdit = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "companies/getDropdown", (result) =>{
          this.companiesDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "campLocations/getDropdown", (result) =>{
          this.campLocationsDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "countries/getDropdown", (result) =>{
          this.countriesDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "contracts/getDropdown", (result) =>{
          this.contractsDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "securityTypes/getDropdown", (result) =>{
          this.securityTypesDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "bvStatuses/getDropdown", (result) =>{
          this.bvStatusDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "armingStatuses/getDropdown", (result) =>{
          this.armingStatusesDropdownValues = result; 
      });
    },
    mounted() { // called afer rendering
      this.isMounted = true; 
    },

    methods:{
      async Submit(e, newStatus){
        e.preventDefault(); 
        //console.log("submitting form");

        const isFormCorrect = await this.v$.$validate();
        // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
        if (!isFormCorrect) return;

        
        if(this.currentLRNote != ""){
          var date = new Date();
          var todaysDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear();
          var thisNote = todaysDate + ": " + this.currentLRNote + "\n"; 

          if(this.myPersonEdit.lrNotes == undefined) this.myPersonEdit.lrNotes = '';
          var notesRaw = thisNote + this.myPersonEdit.lrNotes; 
          this.myPersonEdit.lrNotes = notesRaw;
        }
        if(this.currentACODNote != ""){
          var date = new Date();
          var todaysDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear();
          var thisNote = todaysDate + ": " + this.currentACODNote + "\n"; 

          if(this.myPersonEdit.acodNotes == undefined) this.myPersonEdit.acodNotes = '';
          var notesRaw = thisNote + this.myPersonEdit.acodNotes; 
          this.myPersonEdit.acodNotes = notesRaw;
        }

        if(newStatus != null){
          this.myPersonEdit.armingStatusId = newStatus;
        }

        $.ajax({
            method: "PUT",
            data: JSON.stringify(this.myPersonEdit),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: store.webAPIUrl + "People/putPersonDto/" + this.personId,
            success: (result) => {
                result;
                //var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                //console.log(successMessage);
                ajaxGetAndReturn(store.webAPIUrl + "people/GetContractPersonEdit/" + this.personId, (result) =>{
                  this.myPersonEdit = result; 
                  this.updateText = "Successfully update Record in DB on " + new Date(); 
                  //allow the user ~half a second to hover over the element before the tooltip appears.
                  this.currentLRNote = '';
                  this.currentACODNote = '';
                  this.timer = setTimeout(() => {
                      this.updateText = ''; 
                     
                  }, 1500);
                });
            },
        });
      },
      UpdateForm(objKey, modelData){
        //console.log("dropdowkksajdlfk")
        this.myPersonEdit[objKey] = modelData;
      },
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    },
    validations () {
      return {
        myPersonEdit:{
              spotDTSID: {
                  required:helpers.withMessage("LOA is Required", required)
              },
              campLocationId: {
                    minValue: helpers.withMessage("Camp Location is Required", minValue(1))
              },
              usn: {
                  required:helpers.withMessage("Passport/Taskera/NIN is Required", required)
              },

              dodCiv: {
                  required:helpers.withMessage("Must select DoD Civilian status (Y/N)", required)
              },
              companyId: {
                    minValue: helpers.withMessage("Employer Name is Required", minValue(1))
              },
              deployEndDate:{
                minValue: helpers.withMessage("Deploy End Date Must be AFTER deploy start date.", value => {
                  return new Date(value) > new Date(this.myPersonEdit.deployStartDate); 
                } )
              }
             /*  securityType:{
                required:requiredIf(function(){
                  if(this.myPersonEdit.armingStatusId == 1) return true;
                  return false;
                })
              }, */
              
            },
          }
      }
  }
</script>
  
<style scoped>
.formButtonContainer{
  margin-top:15px;
}
.notesContainerContainer{
  display:flex;
  flex-direction:column;
}
.notesColumn{
  display: flex;
    flex-direction: column;
    text-align: left;
    height: 206px;
    overflow-y: scroll;
    padding:8px;
    border:1px solid lightgray;
    border-radius:3px; 
    background-color:#f2f2f2;
    white-space:pre-wrap;
}
.updateTextContainer{
  display: flex;
    align-self: center;
    align-items: center;
    justify-content: center;
    background: lightblue;
    width: 504px;
    margin-top: 5px;
    border-radius: 3px;
    padding: 4px;
    font-size: 13px;
    font-weight: bolder;
    color: green;
    position: absolute;
    top: -76px;
    left: 14px;
}
.mainContainerPerson{
  width: 85%;
    margin-left: auto;
    margin-right: auto;
    background: lightgreen;
    /* padding: 15px; */
    border-radius: 5px;
    margin-top: 15px;
    padding-bottom: 2px;
    margin-bottom: 10px;
}
.mainContainerPerson h5{
  background: #1E7A1E;
    padding-bottom: 15px;
    padding-top: 15px;
    border-radius: 5px 5px 0px 0px;
    color:white;
}
.formContainerPerson{
    padding: 5px;
    margin: 5px;
    background: #ecf9ec;
    margin-bottom: 15px;
    padding-bottom: 15px;
}
</style>
